import React from 'react';
import './Know.css';
import contactBg from './image/knowus.svg';
import knowbelow from './image/know_below.svg';
import KnowSection from './KnowSection';
import Board from './Board';
import Committe from './Committe';

const Know = () => {
  return (
    <div className="know-page">
      <div className="know-bg-container">
        <img src={contactBg} alt="Know Background" className="know-bg" />
      </div>
      <div className="know-content">
        <div className="know-page1">
          <img src={knowbelow} alt="Know Background Below" className="know-bg-below" />
        </div>
        <KnowSection />
        <Board/>
        <Committe/>
      </div>
    </div>
  );
};

export default Know;
